// frontend/src/components/SeasonCard.js
import React from 'react';

const SeasonCard = ({ season, mediaItem, seasonCount, statusOptions, apiBaseUrl, hasManageRole, onQuickEdit }) => {
  console.log('SeasonCard props:', { season, hasManageRole });
  if (!season) {
    console.error('No season data provided');
    return <div>Error: No season data</div>;
  }

  return (
    <div className="season-card">
      <img
        className="season-poster"
        src={season.vertical_image || season.horizontal_image || 'https://via.placeholder.com/150'}
        alt={season.title_mal || season.title_en || season.title_tmdb || 'Unnamed Season'}
        onError={() => console.log('Image failed to load for season:', season.id)}
      />
      <div className="season-info">
      {/* <h3>
        {season.title_en 
          || season.title_mal 
          | (season.title_tmdb && season.title_tmdb !== mediaItem.title_tmdb 
            ? season.title_tmdb 
            : `Season ${seasonCount || 'Unknown'}`)}
      </h3>         */}
      <h3>
        {season.title_mal || season.title_en || season.title_tmdb || 'Unnamed Season'}
        {season.is_extra && <span className="season-extra-badge">Bonus</span>}
      </h3>
      {hasManageRole ? (
          <>
            <div className="season-field">
              <span>Status:</span>
              <select
                className="quick-edit select-field"
                defaultValue={season.status || 'Plan to Watch'}
                onClick={e => e.stopPropagation()}
                onChange={e => onQuickEdit('status', e.target.value, season.id)}
              >
                {statusOptions.map(status => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </div>
            <div className="season-field episode-field" style={{ display: season.status === 'Finished' ? 'none' : 'block' }}>
              <span>Episode:</span>
              <input
                type="number"
                className="quick-edit input-field"
                min="0"
                max={season.episode_count || undefined}
                defaultValue={season.current_episode || 0}
                onClick={e => e.stopPropagation()}
                onChange={e => onQuickEdit('current_episode', e.target.value, season.id)}
              />
              {season.episode_count && <span className="episode-total">/ {season.episode_count}</span>}
            </div>
            <div className="season-field">
              <span>Score:</span>
              <input
                type="number"
                className="quick-edit input-field"
                min="0"
                max="10"
                step="0.1"
                defaultValue={season.season_score || ''}
                onClick={e => e.stopPropagation()}
                onChange={e => onQuickEdit('season_score', e.target.value, season.id)}
              />
            </div>
          </>
        ) : (
          <>
            <p><strong>Status:</strong> {season.status || 'Unknown'}</p>
            {season.status === 'Watching' && (
              <p>Ep. {season.current_episode || '0'}{season.episode_count ? ` / ${season.episode_count}` : ''}</p>
            )}
            <p><strong>Score:</strong> {season.season_score || '--'}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default SeasonCard;